import { render, staticRenderFns } from "./PostContent.vue?vue&type=template&id=2ccd66d8&scoped=true&"
import script from "./PostContent.vue?vue&type=script&lang=js&"
export * from "./PostContent.vue?vue&type=script&lang=js&"
import style0 from "./PostContent.vue?vue&type=style&index=0&id=2ccd66d8&prod&scoped=true&lang=css&"
import style1 from "./PostContent.vue?vue&type=style&index=1&id=2ccd66d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd66d8",
  null
  
)

export default component.exports